var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu-item-group',{attrs:{"item":_vm.item,"text":"","sub-group":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }